/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react';
import { PageTitle } from '../../../_mexablock/layout/core';
import { DashboardPage } from './components/View';

const DashboardWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Dashboard</PageTitle>
      <DashboardPage />
    </>
  );
};

export { DashboardWrapper };
